import React, { FC } from 'react'
import { useOrganizationsHook } from './Hooks'
import OrganizationsComponent from './Component'

const Organizations: FC = () => {
  return <OrganizationsComponent {...useOrganizationsHook()} />
}
export default Organizations
